
import { useNavigate } from 'react-router-dom';
import logo from '../assets/version2/logo.png';

function Rodape() {


const navigate = useNavigate();


  return (
    <>
    

        <section className="lqd-section footer-menu pt-50 pb-20" style={{backgroundColor: 'rgba(213, 213, 213, 0.49)',
             marginTop: '150px',
              borderTop: '2px solid rgb(227, 227, 227)',
              overflow: 'hidden'}}>
            <div className="container">
                <div className="row">
                    <div className="w-45percent flex flex-col justify-start p-0 ">
                        <div className="flex flex-col py-10 pr-90 pl-10 module-content">
                            <div className="lqd-imggrp-single block relative mb-35">
                            
                                </div>
                                <div className="ld-fancy-heading relative">
                                 
                                 
                                 <img src={logo} style={{width: '300px'}}></img>
                                </div>
                            
                            </div>
                        </div>
                        <div className="w-55percent flex p-0 lg:w-full">
                            <div className="w-full flex flex-wrap p-10 mb-30">
                                <div className="w-33percent sm:w-50percent">
                                    <div className="module-list flex flex-col justify-start mb-30 p-10">
                                        <div className="ld-fancy-heading relative" style={{display: 'flex'}}>
                                            <h3 className="ld-fh-element inline-block relative mb-1/35em text-16 uppercase tracking-1">Lumera 3D</h3>
                                        </div>
                                        <div className="lqd-fancy-menu lqd-custom-menu relative lqd-menu-td-none">
                                            <ul className="reset-ul">
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400" 
                                                    style={{cursor: 'pointer'}}
                                                     onClick={()=> navigate('/sobre')}
                                                    >Sobre nós</a>
                                                </li>
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400" >Como usar</a>
                                                </li>
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400"
                                                    onClick={()=> navigate('/main')}
                                                    style={{cursor: 'pointer'}}
                                                    >Acessar meus Projetos</a>
                                                </li>
                                            
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-33percent sm:w-50percent">
                                    <div className="module-list flex flex-col justify-start mb-30 p-10">
                                        <div className="ld-fancy-heading relative" style={{display: 'flex'}}>
                                            <h3 className="ld-fh-element inline-block relative mb-1/35em text-16 uppercase tracking-1">Legal</h3>
                                        </div>
                                        <div className="lqd-fancy-menu lqd-custom-menu relative lqd-menu-td-none">
                                            <ul className="reset-ul">
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400"
                                                    onClick={()=> navigate('/termosdeuso')}
                                                    style={{cursor: 'pointer'}}
                                                    >Termos de Uso</a>
                                                </li>
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400" 
                                                    onClick={()=> navigate('/politicasdeprivacidade')}
                                                    style={{cursor: 'pointer'}}
                                                    >Política de Privacidade</a>
                                                </li>
                                           
                                        
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-33percent sm:w-50percent">
                                    <div className="module-list flex flex-col justify-start mb-30 p-10">
                                        <div className="ld-fancy-heading relative" style={{display: 'flex'}}>
                                            <h3 className="ld-fh-element inline-block relative mb-1/35em text-16 uppercase tracking-1">Entre em contato</h3>
                                        </div>
                                        <div className="lqd-fancy-menu lqd-custom-menu relative lqd-menu-td-none">
                                            <ul className="reset-ul">
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400">Enviar mensagem</a>
                                                </li>
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400">contato@lumera3d.com</a>
                                                </li>
                                                  <li className="w-full flex items-center mb-10">
                                                        <i class="bi bi-instagram" style={{marginRight: '15px'}}></i>
                                                               <i class="bi bi-facebook" style={{marginRight: '15px'}}></i>
                                                                 <i class="bi bi-linkedin" style={{marginRight: '15px'}}></i>
                                                </li>
                                                 
                             
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
              






              
            </section>


            <div 
style={{width: '100%', backgroundColor: '#36363642', height: '30px', fontFamily: 'Inter, serif',
    fontSize: '11px', color: '#323743', display: 'flex', justifyContent: 'center',
    alignItems: 'center', 
}}
>
    © 2025 Lumera 3D - Uma marca Kollabity Engineering Data
</div>
 
  </>
  );
}

export default Rodape;






